import React from "react";
import "../App.css"; // Or wherever your global CSS is

const RobitoLogo = () => {
  return (
    <h1 className="robito-logo">
      Robito<span className="dot-ai">.Ai</span>
    </h1>
  );
};

export default RobitoLogo;
